import { patch } from './utils'

export async function updateSource(params) {
  const path = Routes.api_v1_payments_source_path()
  const response = await patch(path, params)
  return response.data
}
